export const environment = {
  production: false,
  config: {
    serverUrl: 'https://caregap-inequities-demo.zsservices.com',
    loginUrl:
      'https://idm.zsservices.com/RWDI/IdentityManager/app/Web/login.aspx?ReturnUrl=',
    logoutUrl:
      'https://idm.zsservices.com/RWDI/IdentityManager/app/Web/logout.aspx',
    idmAccountUrl:
      'https://idm.zsservices.com/RWDI/IdentityManager/app/Web/MyAccount.aspx',
    env: 'demo',
    showCareGapDropdown: true,
    hidePatientSegment: false,
    disableHCPs: false,
    maskImpactedPatients: false,
    maskingThreshold: 10,
    systemicHeader: 'Systemic Barriers',
    systemicHeaderPlural: 'Barriers',
    systemicHeaderSingular: 'Barrier',
    accTopBarrierMessage: 'Barriers correspond to Geography of Account and are applicable for prioritized Hotspots only',
    hcpTopBarrierMessage: 'Barriers correspond to Geography of HCP and are applicable for prioritized Hotspots only',
    showNavigationBar: false,
    applicationName: 'Care Gap Intelligence',
  },
};
